import { useMemo } from "react";

import { useModuleConfigurationSchema } from "@/features/integrations/hooks/useModuleConfiguration";
import type { UiComponent } from "@/features/integrations/types";
import { useAuth } from "@/lib/hooks/useAuth";

export interface DirectApplyDataProvider {
  getClientViews(): UiComponent[];
}

export function useDirectApplyDataProvider(
  integrationName: string | undefined,
  clientId?: string | null,
): DirectApplyDataProvider {
  const { tenantId } = useAuth();
  const normalizedName = integrationName?.toLowerCase() || "";

  const schemaQuery = useModuleConfigurationSchema(
    normalizedName,
    "direct-apply",
    clientId
      ? {
        level: "client" as const,
        tenantId: tenantId ?? null,
        clientId,
      }
      : {
        level: "tenant" as const,
        tenantId: tenantId ?? null,
      },
    !!normalizedName,
  );

  return useMemo(() => {
    const ui: UiComponent[] = schemaQuery.data?.ui ?? [];
    return {
      getClientViews: () => ui,
    };
  }, [schemaQuery.data]);
}
